<template>
  <p class="price">
    <template v-if="isOnSale">
      <span class="original-price">{{ originalPrice }}</span>
      <span class="sale-price">{{ price }}</span>
    </template>
    <template v-else>
      {{ price }}
      <span v-if="showSalePreview" class="sale-price">{{
        formattedSalePreviewPrice
      }}</span>
    </template>
    <span v-if="showSaleStartText" class="sale-start">
      {{ saleStartText }}
    </span>
  </p>
</template>

<script>
import { mapGetters } from "vuex";
// import { getFeatureToggles } from "@/helpers/featureToggles.js";
// import { salePreviewTimes } from "@/config.js";
export default {
  name: "ProductCardPrice",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("app", ["currencyCode"]),
    showSalePreview() {
      // TODO: re-enable when sale preview is needed again
      // const { salePreviewEnabled = false } = getFeatureToggles();
      // return salePreviewEnabled && this.salePreviewPrice;
      return false;
    },
    showSaleStartText() {
      // TODO: re-enable when sale preview is needed again
      // const { salePreviewEnabled = false } = getFeatureToggles();
      // return salePreviewEnabled && this.salePreviewPrice;
      return false;
    },
    // TODO: re-enable when sale preview is needed again
    // saleStartText() {
    //   const currencyConfig = salePreviewTimes[this.currencyCode?.toLowerCase()];
    //   return currencyConfig?.displayText || "";
    // },
    formattedSalePreviewPrice() {
      if (!this.salePreviewPrice) return "";

      const isAud = this.currencyCode?.toLowerCase() === "aud";
      const prefix = isAud ? "A$" : "";

      return `${prefix}${this.salePreviewPrice}`;
    },
    salePreviewPrice() {
      return this.product.salePreviewPrice?.value;
    },
    price() {
      const price = this.product.priceRange?.minVariantPrice;
      return this.$filters.toCurrency(price.amount, price.currencyCode, 0);
    },
    originalPrice() {
      const price = this.product.compareAtPriceRange?.minVariantPrice;
      return this.$filters.toCurrency(price.amount, price.currencyCode, 0);
    },
    isOnSale() {
      return (
        parseFloat(this.product.compareAtPriceRange?.minVariantPrice?.amount) >
        parseFloat(this.product.priceRange?.minVariantPrice.amount)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  @include utility-label(14px);
  margin-top: 4px;

  .original-price {
    text-decoration: line-through;
    margin-right: 4px;
  }
  .sale-price {
    color: #d0021b;
    display: block;
  }

  .sale-start {
    color: #d0021b;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    text-transform: uppercase;
    margin-top: 2px;
    display: block;
  }
}
</style>
